import React from 'react'
import './about.css'
import {BsAwardFill} from 'react-icons/bs'
import {FaUserSecret} from 'react-icons/fa'
import {AiFillFolderOpen} from 'react-icons/ai'
import  { useState, useEffect } from 'react';
import setDynamicBackgroundImage from './aboutj'
import Img0 from '../../assets/about.jpg'
import img1 from './img/porti.jpg';
import img2 from './img/expe.png';
import img3 from './img/pro2.jfif';
// import { rgba } from 'react-color-util';


const wherei = [
  {
    id : 1,
   color:"black",
    img:img1,
    head : "clients",
    note : "With backend background and object-oriented design concept, familiar with common design patterns",
    description : " served 16+ clients on Freelancer.com,upwork and fiver",
    icon : <FaUserSecret />
  },
  {
    id : 1,
   color:"red",
    img:img2,
    head : "projects",
    note : "I have solved above 400 question from well known competitive programming sites( Leetcode,Hacker rank,Codeforces)",
    description : "Developed more than 15 projects",
    icon : <BsAwardFill />
  },
  {
    id : 1,
   color:"green",
    img:img3,
    head : "experience",
    note : "Well experienced full-stack web-developer",
    description : " 4+ years of full-stack webdevelopment",
    icon : <AiFillFolderOpen />
  }
];


function Slidepara() {
  const [currentwherei, setCurrentwherei] = useState(0);
  const [currIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setDynamicBackgroundImage(wherei[currentwherei].img, wherei[currentwherei].color);
  }, [currentwherei]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentwherei((currentwherei) => (currentwherei + 1) % wherei.length);
    }, 10000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      {wherei.map((item, index) => {
        return (
          // <div className="slidepara about_card">
            <article
              className={`slidepara-wherei ${
                currentwherei === index ? "active" : ""
              }`}
              key={index}
            >
              {item.icon}
              <h3>{item.head}</h3>
              <h4>{item.description}</h4>
              <small> {item.note} </small>
            </article>
          // </div>
        );
      })}
    </>
  );
}
 
export const About = () => {
  return (
    <section id ="about" >

          <h5> Get to know me</h5>
          {/* <h2>about</h2> */}
      
      
      <div className='container about_container'>
          <div className="about_me">
              <div className="about_me_img">
              <img src= {Img0} />
              </div>
         
              </div>
            
          <div className="slidepara about_card">
          <Slidepara />
          </div>


      </div>
      
      </section >
  )
}

